import { Row, Space, Col, Menu, Dropdown, ConfigProvider, Radio, RadioChangeEvent, Tooltip, Table, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { getBankAccount, getMachineInstallBill, getMachineInstallRequestList, finilizeMachineInstallRequest, newCableRequest, getOnlinePaymentGateway, getLabList, deleteMachineRequest, getMachineList, getParsicUser, getPrintReports } from '../../api/api';
import MachineInstallTable from '../../components/_common/Table/machineInstallTable';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import type { ColumnsType } from 'antd/es/table';
import { UpdateMachineInstallRequestList } from '../../redux/reducers/machineInstallRequestSlice';
import { useNavigate } from 'react-router-dom';
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from '../../services/toast.notification';
import { DownOutlined, DollarOutlined, DeleteOutlined, TagOutlined, ToolOutlined, TeamOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { OnlinePaymentdialog } from './OnlinePaymentdialog';
import { ManualPaymentdialog } from '../financial/ManualPaymentdialog';
import { AssignInstallerDialog } from './AssignInstallerDialog';
import fa_IR from 'antd/lib/locale/fa_IR';
import CustomSelectAntDesign from '../../components/_common/CustomSelectAntDesign';
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";

import { UpdateLabList } from '../../redux/reducers/lablistSlice';
import { LabListContainer } from './style';
import { UpdateMachineList } from '../../redux/reducers/machinelistSlice';
import CustomSelect from '../../components/_common/CustomSelect';
import DownloadPDF from '../../components/_common/DownloadZipFile/DownloadPdfFile';
import toast from 'react-hot-toast';


const MachineInstallRequest = () => {
    const [selectedLab, setSelectedLab] = useState(0);
    const [labList, setLabList] = useState<any[]>([]);
    const [machineList, setMachineList] = useState<any[]>([]);
    const [userList, setUserList] = useState<any[]>([]);

    const [choosenMachine, setChoosenMachine] = useState('-1');
    const [choosenInstaller, setChoosenInstaller] = useState('-1');

    const [selectedStatus, setSelectedStatus] = useState("-1");
    const myStore = useAppSelector((state) => state)
    const [statusList, setStatusList] = useState<any[]>([]);
    const [firstDate, setFirstDate] = useState<any>(undefined);
    const [lastDate, setLastDate] = useState<any>(undefined);
    const [value, setValue] = useState(0);
    var filterItem: any = {};
    const [expandedRowRender] = useState([
        { title: 'آزمایشگاه', val: 'str_LabPersianName' }
        , { title: 'دستگاه', val: 'str_MachineName' }
        , { title: 'وضعیت', val: 'str_state' }
        , { title: 'تاریخ درخواست', val: 'per_RequestDate' }
        , { title: 'تایید مالی', val: 'per_FinancialApproveDateTime' }
        , { title: 'تایید کننده مالی', val: 'financialUser' }
        , { title: 'تاریخ نصب', val: 'per_FinilizeDateTime' }
        , { title: 'نصب کننده', val: 'installuser' }
        , { title: 'کد نصب', val: 'str_InstallationKey' }
        , { title: 'توضیحات درخواست', val: 'str_OrderDescription' }
    ]);

    const columns: ColumnsType<any> = [
        {
            title: 'عملیات',
            width: 70, dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Dropdown overlay={menu(record)}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            <DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            )
        },
        //Table.EXPAND_COLUMN,
        { title: 'آزمایشگاه', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName', width: 100 },

        { title: 'دستگاه', dataIndex: 'str_MachineName', key: 'str_MachineName', width: 150 },
        { title: 'وضعیت', dataIndex: 'str_state', key: 'str_state', width: 100, },
        { title: 'تاریخ درخواست', dataIndex: 'per_RequestDate', key: 'per_RequestDate', width: 90 },
        {
            title: 'تایید مالی', dataIndex: 'per_FinancialApproveDateTime',
            key: 'per_FinancialApproveDateTime', width: 90
        },
        { title: 'تایید کننده مالی', dataIndex: 'financialUser', key: 'financialUser', width: 90 },
        { title: 'تاریخ نصب', dataIndex: 'per_FinilizeDateTime', key: 'per_FinilizeDateTime', width: 90 },
        { title: 'نصب کننده', dataIndex: 'installuser', key: 'installuser', width: 90 },
        {
            title: 'کد نصب', dataIndex: 'str_InstallationKey', key: 'str_InstallationKey', width: 150
            , ellipsis: {
                showTitle: true,
            }
            , render: (str_InstallationKey) => (
                <Tooltip placement="topLeft" title={str_InstallationKey}>
                    {str_InstallationKey}
                </Tooltip>
            )
        },
        {
            title: 'توضیحات درخواست',


            dataIndex: 'str_OrderDescription', key: 'str_OrderDescription'
            , width: 150
            , ellipsis: {
                showTitle: true,
            }
            , render: (str_OrderDescription) => (
                <Tooltip placement="topRight" title={str_OrderDescription}>
                    {str_OrderDescription}
                </Tooltip>
            )
        },


        // {title: '',dataIndex: 'Action',key: 'Action',render:(_,record) => (
        //     <Space size="middle">


        //          {record.int_Status < 10 && (
        //             <Button type="primary" style={{backgroundColor:"red"}} onClick={()=>removeRequest(record.prk_MachineInstallRequest_AutoID)}>حذف</Button>
        //          )}
        //          {(myStore.auth.loginType === 'parsicuser' && record.int_Status <=2) && (
        //             <Button type="primary" style={{backgroundColor:"orange"}} onClick={()=>manualPaymentOnClick(record.prk_MachineInstallRequest_AutoID,record.str_MachineName)}>پرداخت دستی</Button>
        //          )}
        //         {(myStore.auth.loginType === 'labuser' && myStore.auth.taxInfo.Bit_IsTax === true && record.int_Status <=2) && (
        //             <Button type="primary" style={{backgroundColor:"orange"}} onClick={()=>onlinePayment(record.prk_MachineInstallRequest_AutoID,record.str_MachineName)}>پرداخت آنلاین</Button>
        //          )}
        //          {(myStore.auth.loginType === 'parsicuser' && record.int_Status >4 && record.int_Status <10) && (
        //              <Button type="primary" style={{backgroundColor:"blue"}} onClick={()=>reCableRequest(record.prk_MachineInstallRequest_AutoID)}>کابل مجدد</Button>
        //          )}
        //          {(myStore.auth.loginType === 'parsicuser' && record.int_Status >4 && record.int_Status <10) && (
        //              <Button type="primary" style={{backgroundColor:"green"}} onClick={()=>finilizeRequest(record.prk_MachineInstallRequest_AutoID,record.frk_LabID,myStore.auth.userId)}>تکمیل نصب</Button>
        //          )}

        //     </Space>
        // )}, 
    ];

    const menu = (record: any) => (
        <Menu
            items={[
                {
                    key: "1",
                    label: record.bit_deleted ? "بازیابی" : "حذف",
                    onClick: () => removeRequest(record.prk_MachineInstallRequest_AutoID, record.bit_deleted ? false : true),
                    icon: <DeleteOutlined />,
                    disabled: !(record.int_Status < 10) || !permission,
                    danger: true
                },
                {
                    key: "2",
                    label: "پرداخت دستی",
                    onClick: () => manualPaymentOnClick(record.prk_MachineInstallRequest_AutoID, record.str_MachineName, record.prk_ParsicLabBill_AutoID),
                    icon: <DollarOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.int_Status <= 2) || !permission

                },
                // {
                //     key: "3",
                //     label: "پرداخت آنلاین",
                //     onClick: () => onlinePayment(record.prk_MachineInstallRequest_AutoID, record.str_MachineName, record.prk_ParsicLabBill_AutoID),
                //     icon: <TagOutlined />,
                //     disabled: !(myStore.auth.loginType === 'labuser' && myStore.auth.taxInfo.Bit_IsTax === true && record.int_Status <= 2) || !permission

                // },
                {
                    key: "4",
                    label: "کابل مجدد",
                    onClick: () => reCableRequest(record.prk_MachineInstallRequest_AutoID),
                    icon: <ToolOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.int_Status > 4 && record.int_Status < 10) || !permission
                },
                {
                    key: "5",
                    label: "تعیین نصاب",
                    onClick: () => AssignInstaller(record.prk_MachineInstallRequest_AutoID),
                    icon: <TeamOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.int_Status > 4 && record.int_Status < 10) || !permission
                },
                {
                    key: "6",
                    label: "اتمام نصب",
                    onClick: () => finilizeRequest(record.prk_MachineInstallRequest_AutoID, record.frk_LabID, myStore.auth.userId),
                    icon: <CheckCircleOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.int_Status > 4 && record.int_Status < 10) || !permission
                },

            ]}
        />
    )

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [showPaymentDialog, setShowPaymentDialog] = useState(false);
    const [showOnlinePaymentDialog, setShowOnlinePaymentDialog] = useState(false);
    const [showAssignInstallerDialog, setShowAssignInstallerDialog] = useState(false);

    const [paymentDialogPayload, setpaymentDialogPayload] = useState({ requestid: 0, machineName: "", bill: undefined, bankAccount: undefined });
    const [onlinePaymentDialogPayload, setOnlinepaymentDialogPayload] = useState({ requestid: 0, bill: undefined, onlinePaymentGateway: undefined });
    const [assignInstallerDialogPayload, setAssignInstallerDialogPayload] = useState({ requestid: 0 });
    const [permission, setPermission] = useState(false);

    useEffect(() => {
        initFilter();
        loadMachines();
        loadParsicUsers();

        if (myStore.auth.loginType == 'labuser') {
            setSelectedLab(myStore.auth.userId ? +myStore.auth.userId : 0)
            setValue(0)
        }
        else {
            if (!myStore.labList.list) {
                loadLabs()
            }
            else {
                setLabList(myStore.labList.list);
                LabListInitilization(myStore.labList.list);

            }
        }
        loadMachineInstallRequest()

        initStatusList()

        if (myStore.auth.loginType === 'parsicuser') {
            myStore.auth.permission.map((item: any) => {
                if (item.pageName == 'machineInstallRequest')
                    setPermission(item.isDetailAccess);
            });
        }
        else {
            setPermission(true);
        }
    }, [])

    const initFilter = () => {
        filterItem = {}
        let strat = firstDate ? firstDate.format('YYYY-MM-DD') : ''
        let end = lastDate ? lastDate.format('YYYY-MM-DD') : ''

        filterItem.dateFrom = strat
        filterItem.dateTo = end
        filterItem.labId = myStore.auth.loginType == 'labuser' ? myStore.auth.userId ? +myStore.auth.userId : 0 : 0
        filterItem.searchMode = myStore.auth.loginType == 'labuser' ? 0 : 0
        filterItem.status = selectedStatus
        filterItem.machineId = choosenMachine
        filterItem.installer = choosenInstaller
    }

    const onChange = (e: RadioChangeEvent) => {

        console.log('radio checked', e.target.value);
        setValue(e.target.value);
        console.log('value is', value)
        filterItem.searchMode = e.target.value
        filterItem.status = selectedStatus
        filterItem.labId = selectedLab
        let strat = firstDate ? firstDate.format('YYYY-MM-DD') : ''
        let end = lastDate ? lastDate.format('YYYY-MM-DD') : ''
        filterItem.dateFrom = strat
        filterItem.dateTo = end
        filterItem.machineId = choosenMachine
        filterItem.installer = choosenInstaller
        //loadMachineInstallRequest()

    };

    const initStatusList = () => {
        let model1: any = { val: -1, des: 'همه وضعیت ها' }
        let model2: any = { val: 0, des: 'ثبت' }
        let model3: any = { val: 2, des: 'منتظر پرداخت' }
        let model4: any = { val: 4, des: 'تهیه کابل' }
        let model5: any = { val: 6, des: 'درحال نصب' }
        let model6: any = { val: 10, des: 'تکمیل شده' }
        let data: any[] = []
        data.push(model1)
        data.push(model2)
        data.push(model3)
        data.push(model4)
        data.push(model5)
        data.push(model6)
        setStatusList(data)
    }

    const onChangeDatePicker = (dates: any, dateStrings: any, info: any) => {
        console.log(dates);
        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        setFirstDate(dates[0])
        setLastDate(dates[1])

        filterItem.searchMode = value
        filterItem.status = selectedStatus
        filterItem.labId = selectedLab


        filterItem.dateFrom = dateStrings[0] ? dateStrings[0] : ''
        filterItem.dateTo = dateStrings[1] ? dateStrings[1] : ''
        filterItem.machineId = choosenMachine
        filterItem.installer = choosenInstaller
        //loadMachineInstallRequest()
    }
    //     const flatObject=()=>{
    //         
    //     let strat=firstDate?firstDate.format('YYYY-MM-DD'):''
    //     let end=lastDate?lastDate.format('YYYY-MM-DD'):''
    //     let filter:any={}
    //     filter.labId= selectedLab
    //     filter.dateFrom= strat
    //     filter.dateTo= end
    //     filter.searchMode= value
    //     filter.status=selectedStatus
    //     return filter
    //    }

    const loadMachineInstallRequest = (data?: any) => {
        setIsLoading(true);
        filterItem.labId = myStore.auth.loginType == 'labuser' ? myStore.auth.userId : selectedLab
        getMachineInstallRequestList(filterItem)
            .then((result: any) => {
                result.data.data = result.data.data.map((item: any, i: any) => {
                    item['index'] = i
                    return item
                })
                dispatch(UpdateMachineInstallRequestList({ machineInstallRequestList: result.data.data }))
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const loadLabs = () => {
        getLabList()
            .then((result: any) => {
                console.log(result.data.data);
                dispatch(UpdateLabList({ labList: result.data.data }))
                setLabList(myStore.labList.list);
                LabListInitilization(myStore.labList.list)
                // loadMachineInstallRequest();

                loadMachineInstallRequest()
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const LabListInitilization = (labItems: any) => {
        let allLabItem = { prk_AndriodLab_AutoID: 0, str_LabPersianName: "همه آزمایشگاه ها" }
        setLabList([allLabItem, ...labItems])
        setIsLoading(false)
    }

    const machineListInitilization = (machineItems: any) => {
        let allMachineItem = { prk_MachineInfo_AutoID: -1, str_MachineName: "همه دستگاه‌ها" }
        setMachineList([allMachineItem, ...machineItems])
        setIsLoading(false)
    }

    const userListInitilization = (userItems: any) => {
        let allUserItem = { prk_ParsicUser_AutoID: -1, str_FullName: "همه نصاب ها " }
        setUserList([allUserItem, ...userItems])
        setIsLoading(false)
    }

    const addNewOnClick = () => {
        myStore.auth.loginType === "labuser" ? navigate("/labuser/NewMachineInstallRequest") : navigate("/parsicuser/NewMachineInstallRequest")
    }

    const reCableRequest = (machineInstallRequestId: number) => {
        newCableRequest(machineInstallRequestId)
            .then((result: any) => {
                sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
                // loadMachineInstallRequest();
                loadMachineInstallRequest()
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const finilizeRequest = (id: number, labId: number, installerId?: number) => {
        finilizeMachineInstallRequest(id, labId, installerId)
            .then((result: any) => {
                sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
                // loadMachineInstallRequest();
                loadMachineInstallRequest()
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const manualPaymentOnClick = (id: number, machineName: string, billId: number) => {
        setShowPaymentDialog(true);
        setpaymentDialogPayload((values: any) => ({
            ...values,
            requestid: id,
            machineName: machineName,
            withASpecifiBill: true,
        }));


        getBankAccount()
            .then((result: any) => {

                setpaymentDialogPayload((values: any) => ({
                    ...values,
                    bankAccount: result.data.data,
                }));

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })



        getMachineInstallBill(id, billId)
            .then((result: any) => {

                if (result.data.data.length > 0) {

                    setpaymentDialogPayload((values: any) => ({
                        ...values,
                        bill: result.data.data[0],
                    }));

                }

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const onlinePayment = (id: number, machineName: string, billId: number) => {
        setShowOnlinePaymentDialog(true)
        setOnlinepaymentDialogPayload((values: any) => ({
            ...values,
            requestid: id,
        }));

        getMachineInstallBill(id, billId)
            .then((result: any) => {

                if (result.data.data.length > 0) {

                    setOnlinepaymentDialogPayload((values: any) => ({
                        ...values,
                        bill: result.data.data[0],
                    }));

                }

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })


        getOnlinePaymentGateway()
            .then((result: any) => {

                if (result.data.data.length > 0) {

                    setOnlinepaymentDialogPayload((values: any) => ({
                        ...values,
                        onlinePaymentGateway: result.data.data,
                    }));

                }

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const removeRequest = (id: number, deleted: boolean) => {
        setIsLoading(true);
        deleteMachineRequest(id, deleted)
            .then((result: any) => {
                loadMachineInstallRequest();
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const loadMachines = () => {
        getMachineList()
            .then((result: any) => {
                setMachineList(result.data.data)
                dispatch(UpdateMachineList({ machineList: result.data.data }))
                machineListInitilization(result.data.data)
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const loadParsicUsers = () => {
        getParsicUser()
            .then((result: any) => {
                setUserList(result.data.data)
                userListInitilization(result.data.data)

                setIsLoading(false);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })

    }

    const AssignInstaller = (id: number) => {
        setShowAssignInstallerDialog(true)


        setAssignInstallerDialogPayload((values: any) => ({
            ...values,
            requestid: id,
        }));

    }

    const machineHandleChanges = (event: any) => {
        console.log(event)
        console.log(event.target.value);
        setChoosenMachine(event.target.value);
    }

    const installerHandleChanges = (event: any) => {
        console.log(event)
        console.log(event.target.value);
        setChoosenInstaller(event.target.value);
    }

    const addFilter = () => {
        filterItem.status = selectedStatus
        filterItem.labId = selectedLab
        let strat = firstDate ? firstDate.format('YYYY-MM-DD') : ''
        let end = lastDate ? lastDate.format('YYYY-MM-DD') : ''
        filterItem.dateFrom = strat
        filterItem.dateTo = end
        filterItem.searchMode = value == 2 ? 0 : value
        filterItem.machineId = choosenMachine
        filterItem.installer = choosenInstaller
        loadMachineInstallRequest()
    }

    const _printReport = () => {
        setIsLoading(true);
        let toastId: any;

        filterItem.status = selectedStatus
        filterItem.labId = selectedLab
        let strat = firstDate ? firstDate.format('YYYY-MM-DD') : ''
        let end = lastDate ? lastDate.format('YYYY-MM-DD') : ''
        filterItem.dateFrom = strat
        filterItem.dateTo = end
        filterItem.searchMode = value == 2 ? 0 : value
        filterItem.machineId = choosenMachine
        filterItem.installer = choosenInstaller


        let model = {
            "reportType": "InstallMachine",
            "parameters": {
                "labId": selectedLab,
                "DateFrom": firstDate ? firstDate.format('YYYY/MM/DD') : '',
                "DateTo":lastDate ? lastDate.format('YYYY/MM/DD') : '',
                "searchMode": value == 2 ? 0 : value,
                "status": selectedStatus,
                "Installer": choosenInstaller,
                "machineId": choosenMachine
            }
        }
        getPrintReports(model)
            .then((result: any) => {

                if (result.data !== "") {
                    toastId = toast.loading('...درحال آماده سازی فایل گزارش');
                    DownloadPDF(result.data.data, "report");
                    toast.dismiss(toastId);

                }
                else {
                    errorNotify("داده ای برای نمایش وجود ندارد!");
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                toast.dismiss(toastId);
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    return (

        <>
            {isLoading === false && (

                <LabListContainer>
                    <Row justify="space-between" style={{ textAlign: 'right' }}>
                        <Col lg={7} md={12} sm={24} xs={24}>
                            <label style={{ fontSize: '10px' }}>فیلتر بر اساس :</label>
                            <Radio.Group
                                disabled={myStore.auth.loginType == 'labuser' ? true : false}
                                style={{ marginTop: '15px', display: 'inline-block' }}
                                onChange={onChange} value={value}>
                                <Radio value={0}>همه</Radio>
                                <Radio value={1}> تاریخ </Radio>
                                <Radio value={2}> آزمایشگاه</Radio>

                            </Radio.Group>
                        </Col>

                        {value == 2 && (
                            <Col lg={7} md={12} sm={24} xs={24} >
                                <CustomSelectAntDesign
                                    name="lab"
                                    placeholder="آزمایشگاه"
                                    itemList={labList}
                                    disabled={myStore.auth.loginType == 'labuser' ? true : false}
                                    value={(selectedLab == 0) ? "همه آزمایشگاه ها" : selectedLab}
                                    onChange={(x: any) => {
                                        filterItem.labId = x
                                        let strat = firstDate ? firstDate.format('YYYY-MM-DD') : ''
                                        let end = lastDate ? lastDate.format('YYYY-MM-DD') : ''
                                        filterItem.dateFrom = strat
                                        filterItem.dateTo = end
                                        filterItem.searchMode = value
                                        filterItem.status = selectedStatus
                                        setSelectedLab(x);
                                        filterItem.machineId = choosenMachine
                                        filterItem.installer = choosenInstaller
                                        //loadMachineInstallRequest()
                                    }}
                                    valueObjectField={"prk_AndriodLab_AutoID"}
                                    displayObjectField={"str_LabPersianName"}
                                    showSearch={true}
                                />

                            </Col>
                        )}
                        {value == 1 && (
                            <Col lg={7} md={12} sm={24} xs={24}>
                                <>
                                    <div
                                        style={{ marginTop: '4px' }}
                                        className="calender">
                                        <ConfigProvider locale={fa_IR} direction="rtl">
                                            <JalaliLocaleListener />
                                            <DatePickerJalali.RangePicker value={[firstDate, lastDate]}
                                                onCalendarChange={(dates: any, dateStrings: any, info: any) =>
                                                    onChangeDatePicker(dates, dateStrings, info)} />
                                        </ConfigProvider>
                                    </div>
                                </>
                            </Col>
                        )}

                    </Row>
                    <Row>
                        <Col lg={7} md={7} sm={12} xs={12}>
                            <CustomSelect
                                name="machine"
                                placeholder="دستگاه"
                                disabled={myStore.auth.loginType == 'labuser' ? true : false}
                                itemList={machineList}
                                value={choosenMachine || "-1"}
                                onChange={machineHandleChanges}
                                valueObjectField={"prk_MachineInfo_AutoID"}
                                displayObjectField={"str_MachineName"}

                            />
                        </Col>
                        <Col lg={7} md={7} sm={12} xs={12}>
                            <CustomSelect
                                name="parsicUser"
                                placeholder="نصاب دستگاه"
                                disabled={myStore.auth.loginType == 'labuser' ? true : false}
                                itemList={userList}
                                value={choosenInstaller || "-1"}
                                onChange={installerHandleChanges}
                                valueObjectField={"prk_ParsicUser_AutoID"}
                                displayObjectField={"str_FullName"}
                            />
                        </Col>
                        <Col lg={7} md={12} sm={24} xs={24}>
                            <CustomSelect
                                name="status"
                                disabled={myStore.auth.loginType == 'labuser' ? true : false}
                                placeholder="وضعیت"
                                itemList={statusList}
                                value={selectedStatus || "-1"}
                                onChange={(val: any) => {

                                    setSelectedStatus(val.target.value);
                                    filterItem.status = val.target.value
                                    filterItem.labId = selectedLab
                                    let strat = firstDate ? firstDate.format('YYYY-MM-DD') : ''
                                    let end = lastDate ? lastDate.format('YYYY-MM-DD') : ''
                                    filterItem.dateFrom = strat
                                    filterItem.dateTo = end
                                    filterItem.searchMode = value
                                    filterItem.machineId = choosenMachine
                                    filterItem.installer = choosenInstaller
                                    // loadMachineInstallRequest()
                                }}
                                valueObjectField={"val"}
                                displayObjectField={"des"}
                            />
                        </Col>

                    </Row>
                    <Row style={{display:'inline',float:'left'}}>
                        <Button type="primary" onClick={addFilter} disabled={myStore.auth.loginType == 'labuser' ? true : false} >جستجو</Button>
                        <Button type="primary" onClick={_printReport} style={{marginRight:'10px'}}> 
                            چاپ گزارش
                        </Button> </Row>
                </LabListContainer>
            )}
            {/* {myStore.machineInstallRequestList.list && myStore.machineInstallRequestList.list.length > 0 && ( */}
            <Row>
                <MachineInstallTable
                    columns={columns}
                    expandedRowRender={expandedRowRender}
                    data={myStore.machineInstallRequestList.list}
                    isloading={isLoading}
                    onAddClick={addNewOnClick}
                    addButtonTitle={"درخواست نصب جدید"}
                    permission={permission} />
            </Row>
            {/* )
            } */}
            {/* {myStore.machineInstallRequestList.list && myStore.machineInstallRequestList.list.length == 0 && (
                <Row style={{ display: 'flex', justifyContent: 'center', paddingTop: '20px', paddingBottom: '400px' }}>

                    <center><p style={{ color: 'red' }}>با مقادیر انتخاب شده داده ای برای نمایش وجود ندارد.</p></center>

                </Row>
            )} */}

            {showPaymentDialog && (
                <ManualPaymentdialog
                    visible={showPaymentDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setShowPaymentDialog(false); loadMachineInstallRequest(); }}
                    payLoad={paymentDialogPayload}
                    setShowDialog={(value) => setShowPaymentDialog(value)}
                />
            )}

            {showOnlinePaymentDialog && (
                <OnlinePaymentdialog
                    visible={showOnlinePaymentDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setShowOnlinePaymentDialog(false); loadMachineInstallRequest(); }}
                    payLoad={onlinePaymentDialogPayload}
                    setShowDialog={(value) => setShowOnlinePaymentDialog(value)}
                />
            )}


            {showAssignInstallerDialog && (
                <AssignInstallerDialog
                    visible={showAssignInstallerDialog}
                    onSubmit={() => { console.log(true); addFilter(); }}
                    onCancel={() => { setShowAssignInstallerDialog(false); addFilter(); }}
                    payLoad={assignInstallerDialogPayload}
                    setShowDialog={(value) => setShowAssignInstallerDialog(value)}
                />
            )}

        </>
    );
};

export default MachineInstallRequest